import { SummaryStep } from '../../steps/ppoints/SummaryStep';
import { ServiceProviderStep } from '../../steps/ppoints/ServiceProviderStep';
import React from 'react';
import { IntegrationModeStep } from '../../steps/ppoints/IntegrationModeStep';
import { ShippingRateStep } from '../../steps/ppoints/ShippingRateStep';
import { WizardStepName } from '../../../../data/ppoints/constants';
import { IntegrationStatusStep } from 'features/wizard/steps/ppoints/IntegrationStatusStep';

const getWizardStepByName = (name: WizardStepName | null | undefined, onLoadingChange?: (loading: boolean) => void) => {
    if (!name) return <></>;

    switch (name) {
        case WizardStepName.choose_service_provider:
            return <ServiceProviderStep onLoadingChange={onLoadingChange} />;
        case WizardStepName.shipping_zone_rate:
            return <ShippingRateStep onLoadingChange={onLoadingChange} />;
        case WizardStepName.integration_mode_step:
            return <IntegrationModeStep onLoadingChange={onLoadingChange} />;
        case WizardStepName.app_extensions:
            return <IntegrationStatusStep onLoadingChange={onLoadingChange} />;
        case WizardStepName.summary:
            return <SummaryStep />;
        default:
            return <></>;
    }
};

export { getWizardStepByName };
